import { HistoryMessageSegment } from "types/historyMessageTypes";

/**
 * Builds formatted message for CARD history type
 * Add implementation when product owner defines format
 */
export class CardMessageBuilder {
  static build(card: any): HistoryMessageSegment[] {
    // TODO: Define format for CARD type
    return [];
  }
}
